import { render, staticRenderFns } from "./UserReviewSummary.vue?vue&type=template&id=1a77c77e&scoped=true"
import script from "./UserReviewSummary.vue?vue&type=script&lang=js"
export * from "./UserReviewSummary.vue?vue&type=script&lang=js"
import style0 from "./UserReviewSummary.vue?vue&type=style&index=0&id=1a77c77e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a77c77e",
  null
  
)

export default component.exports